import axios from 'axios'
import Cookies from 'js-cookie'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import { ServiceAtom } from '../../recoil/atoms'

interface GetCampaignListResponse {
  campaignId: number
  name: string
  startDate: string
  endDate: string
  //   status: number
  //   description: string
  //   ljType: number
  //   specialCampaign: number
  //   oncePerDayFlag: number
  //   visitCountRefresh: number
  //   nJruleFlag: number
  //   nJruleCount: number
  //   storeGroupRepeat: number
  //   siteStoreGroupFlag: number
  //   campaignJourneyrules: number[]
  //   campaignSiteMapping: number[]
  //   campaignStoregroupMapping: number[]
}

const useGetCampaignList = () => {
  const accessToken = Cookies.get('LoginToken')
  const service = useRecoilValue(ServiceAtom)

  const fetcher = (url: string): Promise<GetCampaignListResponse[]> =>
    axios.get(url).then((res) => res.data.campaignResponse)
  const { data, isLoading } = useSWR(
    () =>
      service.value !== '' && accessToken
        ? `${process.env.REACT_APP_API_DOMAIN}/1/Console/getCampaignList?accessToken=${accessToken}&serviceId=${service.value}`
        : null,
    fetcher,
    { revalidateOnFocus: false, revalidateOnReconnect: false, shouldRetryOnError: false },
  )
  return { campaigns: data, campaignLoading: isLoading }
}

export default useGetCampaignList
